import React from "react";

import PnLCalculator from "../PnLCalculator";
import HeliosNotesSearch from "../../../HeliosNotesSearch";
import MasterBanList from "../MasterBanList";
import { TableWrapper } from "../../styledComponents";

const WatchListBanPnlTab: React.FC = () => {
  return (
    <div>
      <TableWrapper>
        <PnLCalculator />
      </TableWrapper>
      <hr />
      <TableWrapper>
        <MasterBanList />
      </TableWrapper>
      <hr />
      <TableWrapper>
        <HeliosNotesSearch />
      </TableWrapper>
    </div>
  );
};

export default WatchListBanPnlTab;
